import ColumnChart from './columnChart.js';
export default ColumnChart;
